import TableViewMenuColumnsOrder from "@organisms/ViewMenu/TableViewMenu/TableViewMenuColumnsOrder/TableViewMenuColumnsOrder"

import styles from "./PopoverOrderColumns.module.scss"
import { PopoverOrderColumnsProps } from "./PopoverOrderColumns.types"

export default function PopoverOrderColumns(props: PopoverOrderColumnsProps) {
    const { isVisible } = props

    return (
        <div className={styles.base}>
            <TableViewMenuColumnsOrder isVisible={isVisible} />
        </div>
    )
}
